import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation createHoliday($branchId: ID!, $input: CreateHolidayInput!) {
    createHoliday(branchId: $branchId, input: $input) {
      id
      startTime
      endTime
      description
    }
  }
`);

export default function useCreateHoliday() {
  return useMutation(MUTATION, {
    refetchQueries: ['holidays'],
  });
}
